import Vue from 'vue'
import Vuex from 'vuex'
import Products from './products'
import Industries from './industries'
import Types from './types'
import Mediacentres from './mediacentres'

Vue.use(Vuex)

const state = () => ({
    initialized: false,
    filtersFixed: false,
    errors: []
})

const getters = {}

const mutations = {
    setInitialized (state, payload)
    {
        state.initialized = payload
    },
    setFiltersFixed (state, payload)
    {
        state.filtersFixed = payload
    },
    setErrors (state, payload)
    {
        state.errors.push(payload)
    }
}

const actions = {
    init ({
        dispatch,
        commit
    })
    {
        if (window.app.mediacentre_list.productId !== -1)
        {
            commit('setFiltersFixed', true)
        }
        if (window.app.mediacentre_list.type !== '')
        {
            commit('types/setSelected', window.app.mediacentre_list.type)
        }
        Promise.all([
            dispatch('products/get'),
            dispatch('industries/get'),
            dispatch('types/get'),
            dispatch('mediacentres/get')
        ])
            .then(() =>
            {
                commit('setInitialized', true)
            })
    },
    filter ({
        dispatch,
        commit
    })
    {
        commit('mediacentres/resetCurrentPage')
        Promise.all([
            dispatch('mediacentres/get')
        ])
    },
    loadMore ({
        commit,
        dispatch
    })
    {
        commit('mediacentres/increaseCurrentPage')
        Promise.all([
            dispatch('mediacentres/get')
        ])
    }
}

const modules = {
    products: Products,
    industries: Industries,
    types: Types,
    mediacentres: Mediacentres
}

export default new Vuex.Store({
    state,
    getters,
    mutations,
    actions,
    modules
})
